import axios from '../../helpers/axiosConfig';
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import getBaseUrl from '../../helpers/utility';
import '../../index.css';

import { AuthContext } from '../../helpers/AuthContext';
function Dcca() {
  const baseUrl = getBaseUrl();
  /*   const { authState } = useContext(AuthContext);
    const isInfocomm = authState.user && (authState.user.username === 'dcca' || authState.user.username === 'colrodi'); */


  const [currentGroup, setCurrentGroup] = useState(0);
  const navigate = useNavigate();
  const [directeur, setDirecteur] = useState([]);
  const [isPaused, setIsPaused] = useState(false);

  const [direct, setDirect] = useState(null);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  const groups = directeur.reduce((acc, item, idx) => {
    if (idx % 4 === 0) acc.push([]);
    acc[acc.length - 1].push(item);
    return acc;
  }, []);

  const prev = () => setCurrentGroup(currentGroup === 0 ? groups.length - 1 : currentGroup - 1);
  const next = () => setCurrentGroup(currentGroup === groups.length - 1 ? 0 : currentGroup + 1);



  const Etsouservice = ({ observation }) => {
    const [etsouservices, setEtsouservices] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`etsouservice/byObservation/${observation}`);
          setEtsouservices(response.data);
        } catch (error) {
          toast.error(`Erreur lors du chargement des Etsouservice pour ${observation}:`, error);
        }
      };

      fetchData();
    }, [observation]);


    return (
      <ul>
        {etsouservices.map((etsouservice) => (
          <li key={etsouservice.id}>{etsouservice.name}</li>
        ))}
      </ul>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/directeurs');
        setDirecteur(response.data);
      } catch (err) {
        toast.error(err.response.error);
      }
    };
    fetchData();
  }, []);



  useEffect(() => {
    axios
      .get("directeurs/last/directeur/2x12")
      .then((res) => {
        setDirect(res.data);
      })
      .catch((err) => console.log(err));
  }, []);




  const [openSection, setOpenSection] = useState(null);

  const toggle = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const menuItems = [
    {
      id: "services",
      title: "SERVICES",
      items: ["CAB", "SAF", "SAG", "INFOCOMM", "PRMP", "SPCM", "SOLDE"],
    },
    {
      id: "etablissements",
      title: "ÉTABLISSEMENTS",
      items: ["ECMAG", "EMIH", "EIA"],
    },
    {
      id: "ecoles",
      title: "ÉCOLES",
      items: ["CEFAA"],
    },
  ];


  return (
    <div className="mt-3">

      {/* {{ knp_pagination_render(directeurs) }} */}



      <div className="mx-5 flex flex-col md:flex-row justify-between items-center gap-6">

        {/* Logo EMA */}
        <div className="mb-3 text-center animate-fade-in-left">
          <img
            src="/images/logo_dcca/EMA.jfif"
            className="rounded w-64 object-contain hover:scale-105 transition-transform duration-300"
            alt=""
          />
        </div>

        {/* Directeur */}
        <div className="mb-3 text-center flex flex-col items-center">
          <img
            src={
              direct?.personnel?.filename
                ? `${baseUrl}/images/personnels/${direct.personnel.filename}`
                : "/images/logo_dcca/SAMSEASSIMO.jpg" // image par défaut si pas encore de directeur en base
            }
            className="rounded w-64 object-contain hover:scale-105 transition-transform duration-300 shadow-lg"
            alt="Directeur"
          />
          <div className="mt-3 text-gray-600 text-sm">
            <p>Directeur de la Direction Centrale</p>
            <p>du Commissariat des Armées</p>
          </div>
          <div className="mt-3">
            <h5 className="text-base font-semibold text-gray-800 uppercase tracking-wide">
              {direct?.personnel?.grade?.name || "Intendant-Général"}
            </h5>
            <p className="font-bold text-green-700 mt-1">
              {direct?.personnel?.nomprenom || "SAMSE ASSIMO Andriamialy"}
            </p>
          </div>
        </div>


        {/* Logo DCCA */}
        <div className="mb-3 text-center">
          <img
            src="/images/logo_dcca/DCCA.jpg"
            className="rounded w-64 object-contain hover:scale-105 transition-transform duration-300"
            alt=""
          />
        </div>

      </div>


      <div className="">
        <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#carouselExampleCaptions" data-slide-to="0" className="active"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
          </ol>
          <div className="carousel-inner ">


            <div className="carousel-item active">
              <img src="/images/app-img/d.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>


            <div className="carousel-item ">
              <img src="/images/app-img/g.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/h.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>
            <div className="carousel-item">
              <img src="/images/app-img/a.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/b.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/e.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/i.jpeg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/j.jpeg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>
          </div>
          <a className="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>



      <div className="w-full mb-4 mt-4">
        <div className="bg-gradient-to-r from-green-700 via-green-600 to-green-700 rounded-2xl px-8 py-6 text-center shadow-lg">
          <p className="text-green-200 text-xs font-bold uppercase tracking-widest mb-2">DCCA</p>
          <h1 className="text-white text-2xl font-bold tracking-wide">
            Les Directeurs Successifs de la DCCA
          </h1>
          <div className="w-16 h-1 bg-green-300 rounded-full mx-auto mt-3"></div>
        </div>
      </div>

      <div className="w-full mt-4 mb-4">

        {/* Carousel container */}
        <div className="relative bg-gradient-to-br from-slate-50 to-green-50 rounded-2xl p-6 border border-green-100 shadow-sm overflow-hidden">

          {/* Décoration fond */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-green-100 rounded-full opacity-30 -translate-y-1/2 translate-x-1/2"></div>

          {/* Cartes directeurs */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 px-4">
            {groups[currentGroup]?.map((dir, key) => (
              <div
                key={key}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 overflow-hidden"
              >
                {/* Photo */}
                <div className="w-full h-52 overflow-hidden bg-gray-100">
                  <img
                    src={
                      dir?.personnel?.filename
                        ? `${baseUrl}/images/personnels/${dir.personnel.filename}`
                        : ``
                    }
                    alt="directeur"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>

                {/* Infos */}
                <div className="bg-gradient-to-b from-green-600 to-green-800 p-3 text-center">
                  <h6 className="text-white font-bold text-sm leading-tight mb-1">
                    {dir.personnel?.grade?.name}
                  </h6>
                  <p className="text-green-100 font-semibold text-sm leading-tight mb-2">
                    {dir.personnel?.nomprenom}
                  </p>
                  <span className="inline-block bg-white/20 text-white text-xs px-3 py-1 rounded-full">
                    {dir.du} — {dir.au}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Boutons navigation */}
          <button
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-white hover:bg-green-600 hover:text-white text-green-700 border border-green-200 shadow-md rounded-full w-10 h-10 flex items-center justify-center transition-all duration-200"
          >
            ‹
          </button>
          <button
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-white hover:bg-green-600 hover:text-white text-green-700 border border-green-200 shadow-md rounded-full w-10 h-10 flex items-center justify-center transition-all duration-200"
          >
            ›
          </button>

          {/* Indicateurs dots */}
          <div className="flex justify-center gap-2 mt-5">
            {groups.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentGroup(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentGroup
                  ? 'bg-green-600 w-6'
                  : 'bg-green-200 hover:bg-green-400'
                  }`}
              />
            ))}
          </div>

        </div>
      </div>



      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-6">

          {/* Sidebar */}
          <div className="w-full md:w-64 shrink-0">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              {menuItems.map((menu) => (
                <div key={menu.id} className="border-b border-gray-100 last:border-0">
                  <button
                    onClick={() => toggle(menu.id)}
                    className="w-full flex items-center justify-between px-5 py-4 text-sm font-semibold text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-200"
                  >
                    <span>{menu.title}</span>
                    <span className={`transform transition-transform duration-200 ${openSection === menu.id ? "rotate-180" : ""}`}>
                      ▾
                    </span>
                  </button>
                  {openSection === menu.id && (
                    <ul className="bg-gray-50 px-4 pb-3">
                      {menu.items.map((item) => (
                        <li
                          key={item}
                          className="py-2 px-3 text-sm text-gray-600 hover:text-green-700 hover:bg-green-50 rounded-lg cursor-pointer transition-colors duration-150"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Contenu principal */}
          <div className="flex-1">

            {/* Header */}
            <div className="bg-green-700 text-white rounded-2xl px-6 py-4 mb-6 shadow-sm">
              <h2 className="text-lg font-semibold tracking-wide">
                Historique de la DCCA
              </h2>
            </div>

            {/* Présentation */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-1 h-6 bg-green-600 rounded-full"></div>
                <h3 className="text-base font-semibold text-gray-800">Présentation</h3>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                La Direction Centrale du Commissariat des Armées (DCCA) est rattachée au niveau
                de l'État-Major des Armées. Elle est responsable de l'administration au sein des
                Forces Armées Malagasy. La DCCA a pour objectif :{" "}
                <span className="font-medium text-green-700">
                  « Tanindrazana – Fitantanana – Fahamarinana »
                </span>.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                La DCCA est placée sous le patronage de Saint Martin, célébré chaque année le{" "}
                <span className="font-medium text-gray-800">11 novembre</span>, et est implantée
                au camp de l'Intendant Général{" "}
                <span className="font-medium text-gray-800">RASOLOMALALA Jean Jacques</span>,
                CAPSAT Soanierana.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                Les Établissements constituant la DCCA sont : l'ECMAG, l'EIH, l'EIA et le CEFAA.
                Elle dispose de{" "}
                <span className="font-semibold text-green-700">dix Bureaux Régionaux (BRCA)</span>{" "}
                : Antsiranana, Antananarivo, Toliary, Morondava, Taolagnaro, Tsiroanomandidy,
                Toamasina, Fianarantsoa, Manakara et Mahajanga.
              </p>
            </div>

            {/* BRCA Grid */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-1 h-6 bg-green-600 rounded-full"></div>
                <h3 className="text-base font-semibold text-gray-800">Bureaux Régionaux (BRCA)</h3>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
                {["Antsiranana", "Antananarivo", "Toliary", "Morondava", "Taolagnaro",
                  "Tsiroanomandidy", "Toamasina", "Fianarantsoa", "Manakara", "Mahajanga"
                ].map((brca) => (
                  <div
                    key={brca}
                    className="bg-green-50 text-green-800 text-xs font-medium text-center py-2 px-3 rounded-xl border border-green-100"
                  >
                    {brca}
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="map-capsat mt-2">
        <div className="list-group-item list-group-item-warning">
          Google map - DCCA/CAPSAT Soanierana
        </div>

        <div className="col-md-12 card-body mt-2">
          <iframe
            className="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2695.158064852258!2d47.52372718653123!3d-18.937708513181054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x21f07e7f22278151%3A0x9bf8193928e7eab6!2sCAPSAT+Madagascar!5e1!3m2!1sfr!2smg!4v1554899491631!5m2!1sfr!2smg"
            width="100%"
            height="450"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
          />
        </div>
      </div>

    </div>
  );
}

export default Dcca;
